/**
 * 路由守卫
 */
import { inject } from 'muqali';
import { CDN } from '@/global.js';
import store from '@/store';
export function bindGuards(router) {
    router.beforeEach(async (to, from, next) => {
        if (from.fullPath === '/') {
            window.firstPage = to.fullPath;
        }
        //校园活动统一获取学科及活动类型
        if (
            /\/campusActivities\//i.test(to.path) &&
            store.state.activity.subjectList.length === 0
        ) {
            store.dispatch('getSubjectList');
        }
        //teacher parent student 添加shanks
        if (
            /\/teacher\/|\/parent\/|\/student\/|\/activity\/|\/personality-counseling\/|\/pencil-case\//i.test(
                to.path
            )
        ) {
            inject({
                url: CDN + '/s17/lib/shanks/2.0.8/seed.min.js',
            })
                .catch((v) => console.log(v))
                .finally(() => {
                    return next();
                });
        } else {
            return next();
        }
    });
    router.afterEach((to, from) => {
        to, from;
    });
}
